import styled from 'styled-components';
import { PageContainer } from '@dealstack/frontend/shared/layout/PageContainer/PageContainer.tsx';

export const HelpBlogPageContainer = styled(PageContainer)`
	height: auto;

	.page-container {
		min-height: 80vh;
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
		border-bottom: 0;
		border-radius: 0.25rem;
		padding-bottom: 2rem;
	}

	.container {
		max-width: 1084px;
		width: 100%;
		margin: 0 auto;
	}

	.header {
		max-width: 534px;
		margin: 5rem auto;
	}

	.page-title,
	.subtitle {
		margin-bottom: 1rem;
		text-align: center;
	}

	.subtitle {
		color: ${({ theme }) => theme.v3.colors.dark[0]};
	}

	.search {
		margin-bottom: 1.6rem;
	}

	.col {
		flex: 0 1 calc(50% - 0.75rem);
	}

	.loading {
		animation: loadingAnim 1.2s ease-in-out infinite;
		pointer-events: none;
	}

	.contact-link {
		border-radius: 0.25rem;
		padding: 0.5rem;
		transition: background 0.3s ease;

		&:hover {
			background: ${({ theme }) => theme.v3.colors.gray[0]};
		}
	}

	@keyframes loadingAnim {
		0% {
			opacity: 1;
		}
		50% {
			opacity: 0.5;
		}
		100% {
			opacity: 1;
		}
	}
`;
